import React from 'react';

import { View, Text, StyleSheet } from 'react-native';

import {
  OPComponent,
  Container,
  IconButton,
  IconRow,
  I18n,
  ProfileAvatar,
  Navigation,
} from '../../components';

import moment from 'moment';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  getEditingCase,
  getEditingCasePatient,
  getEditingCaseEmployer,
  getEditingCasePatientProfile,
} from '../selector';
import { changeCurrentCase } from '../actions';

import { getLocationsByRegionForEditingCaseEmployer } from '../../medRecruiter/selector';

import { INVITATIONS, PATIENT_INFO, RESIDENT_ADMINISTRATION } from '../../../constants/permissions';
import { VA_ADMIN_CHAP, VA_PROVIDER } from '../../../constants/patientRoles';
import { editingCasePermissions } from '../../../helpers/permissions';

import ResendPatientInvite from '../../invite/resend_patient_invite';
import PatientInfo from '../../patient/medRecruiter/patient_info';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';

class CaseInfoMedRecruiter extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      resendPatientInviteError: null,
      resendPatientInviteStatus: null,
      sendSuccessMessage: null,
      atLeastOneFormSaved: false,
    };
  }

  componentDidMount() {}
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState) {}

  handleResendPatientInviteStatus = (resendPatientInviteStatus) => {
    this.setState({
      resendPatientInviteStatus,
    });
  };
  handleResendPatientInviteError = (resendPatientInviteError) => {
    this.setState({ resendPatientInviteError });
  };
  handleResendPatientInviteSuccess = (sendSuccessMessage) => {
    this.setState({ sendSuccessMessage });
  };

  _goToSubScreen = (screenName, title, passProps) => {
    Navigation.push(
      {
        screen: screenName,
        title: title,
        passProps,
      },
      this.props.componentId
    );
  };

  goToSchedule = () => {
    Navigation.dismissAllModals();
    this.props.actions.changeCurrentCase(this.props.editingCase.caseId);
    Navigation.handleDeepLink({
      link: 'employer/main',
    });
  };

  render() {
    const props = this.props;

    if (!props.canViewEditingCase) return null;

    const successMessage = this.state.sendSuccessMessage || this.props.caseCreateSuccessMessage;
    const errorMessage = this.state.resendPatientInviteError;

    const roleDescription = props.editingCasePatient?.role;
    const isProvider = [VA_ADMIN_CHAP, VA_PROVIDER].includes(roleDescription);

    const startDate = props.editingCase.start_date
      ? moment(props.editingCase.start_date).format('MM/DD/YYYY')
      : '';

    return (
      <Container
        actionSheet={true}
        scrollView={true}
        renderActivityOverlay={
          !props.editingCase || this.state.resendPatientInviteStatus === REQUESTING
        }
        successMessage={successMessage}
        errorMessage={errorMessage}
      >
        <View style={styles.header}>
          <ProfileAvatar initialsStr={props.editingCase.name} profile={props.patientProfile} />
          <Text style={styles.headerText}>{props.editingCase.name}</Text>
        </View>

        <ResendPatientInvite
          editingCase={props.editingCase}
          editingCasePatient={props.editingCasePatient}
          canEditInvites={props.canEditPatientInvites}
          editingCaseEmployer={props.editingCaseEmployer}
          onStatus={this.handleResendPatientInviteStatus}
          onError={this.handleResendPatientInviteError}
          onSuccess={this.handleResendPatientInviteSuccess}
        />

        {!!isProvider && (
          <IconButton
            label={I18n.c1('medRecruiter.schedule')}
            noTopBorder={true}
            imageSource={require('../../../../resources/icon-schedule.png')}
            value={null}
            onPress={this.goToSchedule}
          />
        )}

        <IconRow
          imageSource={require('../../../../resources/icon-staff.png')}
          label={roleDescription ? `${roleDescription} Of` : I18n.aec('case.residentOf')}
          value={props.editingCaseEmployer.name}
          topBorder={false}
          bottomBorder={false}
        />

        <IconRow
          imageSource={require('../../../../resources/icon-location.png')}
          label={I18n.c1('medRecruiter.vaLocation')}
          value={props.vaLocation}
          topBorder={true}
        />
        <IconRow
          imageSource={require('../../../../resources/icon-region.png')}
          label={I18n.c1('medRecruiter.region')}
          value={props.region}
          topBorder={false}
        />
        <IconRow
          imageSource={require('../../../../resources/icon-start-date.png')}
          label={I18n.c1('medRecruiter.startDate')}
          value={startDate}
          topBorder={false}
        />

        <PatientInfo
          employer={props.editingCaseEmployer}
          case={props.editingCase}
          patient={props.editingCasePatient}
          goToSubScreen={this._goToSubScreen}
        />
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    ...THEME.header,
    alignItems: 'center',
  },
  headerText: {
    ...THEME.headerText,
    marginTop: 10,
  },
});

function mapStateToProps(state, ownProps) {
  const editingCase = getEditingCase(state);
  const locationsByRegion = getLocationsByRegionForEditingCaseEmployer(state);
  let location = null;
  Object.values(locationsByRegion || {}).forEach((ls) => {
    const found = ls.find((l) => l.clinical_location_id === editingCase?.clinical_location_id);
    if (found) location = found;
  });
  const regions = state.entities.metaData.vaRegions || [];
  return {
    editingCaseEmployer: getEditingCaseEmployer(state),
    editingCase,
    editingCasePatient: getEditingCasePatient(state),
    canViewEditingCase: editingCasePermissions(RESIDENT_ADMINISTRATION).canView,
    canEditPatientInvites: editingCasePermissions(INVITATIONS).canEdit,
    patientProfile: getEditingCasePatientProfile(state),
    vaLocation: location?.name,
    region: regions.find((r) => r.id === location?.va_region)?.name,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ changeCurrentCase }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseInfoMedRecruiter);
